import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  droneCategory: [],
  loading: false,
  error: null,
};

const droneCategorySlice = createSlice({
  name: 'droneCategory',
  initialState,
  reducers: {
    getDroneCategory(state) {
      state.loading = true;
    },
    getDroneCategorySuccess(state, action) {
      state.loading = false;
      state.droneCategory = action.payload;
      state.error = null;
    },
    getDroneCategoryFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { getDroneCategory, getDroneCategorySuccess, getDroneCategoryFailure } = droneCategorySlice.actions;

export default droneCategorySlice.reducer;
